import { render, staticRenderFns } from "./TermsOfServicePage.vue?vue&type=template&id=0a10218a&scoped=true&"
import script from "./TermsOfServicePage.vue?vue&type=script&lang=ts&"
export * from "./TermsOfServicePage.vue?vue&type=script&lang=ts&"
import style0 from "./TermsOfServicePage.vue?vue&type=style&index=0&id=0a10218a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10218a",
  null
  
)

export default component.exports